import { FontStatus } from 'editor/src/store/fonts/types';
import { RootState } from 'editor/src/store/index';

import getFontDefinition from './getFontDefinition';

const isFontLoaded = (state: RootState, fontFile: string) => {
  const fontDef = getFontDefinition(state, fontFile);
  if (fontDef) {
    return fontDef.status === FontStatus.ready;
  }

  // Check uploaded fonts directly
  const uploaded = state.fonts.uploadedFonts.find((f) => f.fontFile === fontFile);
  return uploaded?.loadingStatus === FontStatus.ready;
};

export default isFontLoaded;
